import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _dec, _dec2, _class;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import Link from '../../../components/Link';
import messages from '../coursesMessges';
import s from './DashboardDiscussions.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var DashboardDiscussions = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    lang: state.intl.locale
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardDiscussions, _React$Component);
  var _super = _createSuper(DashboardDiscussions);
  function DashboardDiscussions() {
    _classCallCheck(this, DashboardDiscussions);
    return _super.apply(this, arguments);
  }
  _createClass(DashboardDiscussions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        followedDiscussions = _this$props.followedDiscussions,
        discussions = _this$props.discussions;
      if (_.isEmpty(followedDiscussions) && _.isEmpty(discussions)) {
        return null;
      }
      return /*#__PURE__*/_jsx("div", {
        className: s.trendingTopicsAndNews
      }, void 0, /*#__PURE__*/_jsx("h2", {}, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.discussionsTitle)), !_.isEmpty(discussions) && /*#__PURE__*/_jsx("div", {
        className: s.forum
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.forumLabel
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.classroomTitle)), /*#__PURE__*/_jsx("div", {
        className: s.forumItems
      }, void 0, _.map(discussions, function (discussion) {
        return /*#__PURE__*/_jsx("div", {
          className: s.discussionItem
        }, _.get(discussion, '_id'), /*#__PURE__*/_jsx(Link, {
          className: s.discussionLink,
          to: "/classroom/followed-discussions/".concat(_.get(discussion, '_id'))
        }, void 0, discussion.name), /*#__PURE__*/_jsx("div", {
          className: classNames(s.flex, s.postDate)
        }, void 0, /*#__PURE__*/_jsx(Typography, {
          className: s.discussionDate
        }, void 0, moment(_.get(discussion, 'latestResponse.createDate')).format('DD/MM/YYYY HH:mm')), "\xA0", _.get(discussion, 'latestResponse.createdBy._id') && /*#__PURE__*/_jsx(Typography, {
          className: s.discussionAuthor,
          component: Link,
          to: "/profiles/".concat(_.get(discussion, 'latestResponse.createdBy._id'))
        }, void 0, _.get(discussion, 'latestResponse.createdBy.lastName', ''), "\xA0", _.get(discussion, 'latestResponse.createdBy.firstName', ''))));
      }))), !_.isEmpty(followedDiscussions) && /*#__PURE__*/_jsx("div", {
        className: s.news
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.newsLabel
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.followedTitle)), /*#__PURE__*/_jsx("div", {
        className: s.newsItems
      }, void 0, _.map(followedDiscussions, function (discussion) {
        return /*#__PURE__*/_jsx("div", {}, _.get(discussion, '_id'), /*#__PURE__*/_jsx(Link, {
          className: s.discussionLink,
          to: "/classroom/followed-discussions/".concat(_.get(discussion, '_id'))
        }, void 0, discussion.name), /*#__PURE__*/_jsx("div", {
          className: classNames(s.flex, s.postDate)
        }, void 0, /*#__PURE__*/_jsx(Typography, {
          className: s.discussionDate
        }, void 0, moment(_.get(discussion, 'latestResponse.createDate')).format('DD/MM/YYYY HH:mm')), "\xA0", /*#__PURE__*/_jsx(Typography, {
          className: s.discussionAuthor,
          component: Link,
          to: "/profiles/".concat(_.get(discussion, 'latestResponse.createdBy._id'))
        }, void 0, _.get(discussion, 'latestResponse.createdBy.lastName', ''), "\xA0", _.get(discussion, 'latestResponse.createdBy.firstName', ''))));
      }))));
    }
  }]);
  return DashboardDiscussions;
}(React.Component)) || _class) || _class) || _class);
export { DashboardDiscussions as default };